var scorm = pipwerks.SCORM; //Shortcut
var lmsConnected = false;
var unloaded = false;
var courseURL = btoa(window.location.href.toString());
var progressURL = 'progress' + courseURL;
var bookmarkURL = 'bookmark' + courseURL;

function initCourse() {
	// Do we even want to talk to the LMS?
	if (globalVar.scormSettings.useScorm) {
		if (globalVar.scormSettings.standard.toLowerCase() !== 'aicc') {
			connectToSCORMAPI();
		} else {
			connectToAICCAPI();
		}
	} else if (globalVar.scormSettings.useLocal) {
		connectToLocalStorage();
	} else {
		siLog('SCORM', 'INFO', 'SCORM is disabled.');
	}
}

function connectToAICCAPI() {
	var SD = window.parent;

	if (typeof SD.SetReachedEnd === 'function' && typeof SD.CommitData === 'function') {
		siLog('AICC', 'API', 'SUCCESS: AICC API found!');
		siLog('AICC', 'INIT', 'SUCCESS: Course is now connected to the LMS!');
	} else {
		siLog('AICC', 'API', 'ERROR: AICC API not found!');
		siLog('AICC', 'INIT', 'ERROR: Course could not connect to the LMS!');
	}
}
function connectToLocalStorage() {
	if (storageAvailable('localStorage')) {
		var rawLocalData = localStorage.getItem(progressURL);
		if (rawLocalData && typeof rawLocalData === 'string') {
			var localData = JSON.parse(rawLocalData);
			saveData = localData;
		} else {
			saveData = {
				completionStatus: 'incomplete',
				learnerName: 'Maria',
				learnerId: '12345',
				totalTime: '0',
				bookmark: 1,
				score: '0',
				lastSlideType: 'text',
				currentVideoTime: 0
			};
		}
		window.addEventListener('unload', unloadHandler);
		window.addEventListener('beforeunload', unloadHandler);
	}
}

function connectToSCORMAPI() {
	//scorm.init returns a boolean
	lmsConnected = scorm.init();
	//If the scorm.init function succeeded...
	if (lmsConnected) {
		siLog('SCORM', 'INIT', 'SUCCESS: Course is now connected with the LMS!');
		var completionstatus;
		var learnername, learnerId, totalTime, learnerScore;
		var rawData = scorm.get('cmi.suspend_data');
		var bookmarkScorm;
		var scormData;
		if (scorm.version === '2004') {
			completionstatus = scorm.get('cmi.completion_status');
			learnername = scorm.get('cmi.learner_name');
			learnerId = scorm.get('cmi.learner_id');
			totalTime = scorm.get('cmi.total_time');
			learnerScore = scorm.get('cmi.score.raw');
			bookmarkScorm = scorm.get('cmi.location');
		} else {
			completionstatus = scorm.get('cmi.core.lesson_status');
			learnername = scorm.get('cmi.core.student_name');
			learnerId = scorm.get('cmi.core.student_id');
			totalTime = scorm.get('cmi.core.total_time');
			learnerScore = scorm.get('cmi.core.score.raw');
			bookmarkScorm = scorm.get('cmi.core.lesson_location');
		}
		if (rawData && typeof rawData === 'string') {
			scormData = JSON.parse(rawData);
			saveData = scormData;
			// compare information received from LMS to what we stored.  Give priority to higher values
			if (bookmarkScorm) {
				saveData.bookmark = bookmarkScorm > saveData.bookmark ? bookmarkScorm : saveData.bookmark;
			}
			if (learnerScore) {
				saveData.score = learnerScore > saveData.score ? learnerScore : saveData.score;
			}
			if (totalTime) {
				saveData.totalTime = totalTime > saveData.totalTime ? totalTime : saveData.totalTime;
			}
		} else {
			saveData = {
				completionStatus: completionstatus ? completionstatus : 'incomplete',
				learnerName: learnername ? learnername : 'Maria',
				learnerId: learnerId ? learnerId : '12345',
				totalTime: totalTime ? totalTime : '0',
				bookmark: bookmarkScorm ? bookmarkScorm : 1,
				score: learnerScore ? learnerScore : '0',
				lastSlideType: 'text',
				currentVideoTime: 0
			};
		}

		window.addEventListener('unload', unloadHandler);
		window.addEventListener('beforeunload', unloadHandler);
		//If the course couldn't connect to the LMS for some reason...
	} else if (globalVar.scormSettings.useLocal) {
		siLog('SCORM', 'INIT', 'ERROR: Course could not connect with the LMS, attempting local storage');
		connectToLocalStorage();
	} else {
		//... let's alert the user then close the window.
		siLog('SCORM', 'INIT', 'ERROR: Course could not connect with the LMS');
	}
}

function setScormCompletion() {
	var success = false;

	// Do we even want to talk to the LMS?
	if (globalVar.scormSettings.useScorm) {
		// AICC:
		// On the off chance that we want to use AICC instead of SCORM

		if (globalVar.scormSettings.standard === 'aicc') {
			var SD = window.parent;

			// Check if the AICC API is available in parent and tell it to set the course to complete

			if (typeof SD.SetReachedEnd === 'function' && typeof SD.CommitData === 'function') {
				// If both of the following AICC API functions return true, we are done here!
				success = SD.SetReachedEnd() && SD.CommitData();
				if (success) {
					siLog('AICC', 'COMPLETE', 'SUCCESS: Course was successfully set to complete!');
				}
				// otherwise something went horribly wrong.
				else {
					siLog('AICC', 'COMPLETE', 'ERROR: Course could not be set to complete!');
				}
			}
			// otherwise the API isn't available
			else {
				siLog('AICC', 'COMPLETE', 'ERROR: Course is not connected to the LMS');
			}
		}

		// SCORM:

		//If lmsConnected is true (which only happens if we are using the SCORM standard)...
		else if (lmsConnected) {
			//... try setting the course status to "completed"
			if (scorm.version === '2004') {
				success = scorm.set('cmi.completion_status', 'completed');
				scorm.set('cmi.success_status', 'passed');
				scorm.set('cmi.score.raw', '100');
				scorm.set('cmi.score.scaled', '1');
				// scorm.set("cmi.score.min", globalVar.minScore);
				// scorm.set("cmi.score.max", globalVar.maxScore);
				// scorm.set("adl.nav.request", "exit")
			} else {
				success = scorm.set('cmi.core.lesson_status', 'completed');
				scorm.set('cmi.core.score.raw', '100');
				// scorm.set("cmi.core.score.min", globalVar.minScore);
				// scorm.set("cmi.core.score.max", globalVar.maxScore);
			}
			//If the course was successfully set to "completed"...
			if (success) {
				scorm.save();
				siLog('SCORM', 'COMPLETE', 'SUCCESS: Course was successfully set to complete!');
			}
			//If the course couldn't be set to completed for some reason...
			else {
				//alert the user
				siLog('SCORM', 'COMPLETE', 'ERROR: Course could not be set to complete!');
			}
		}
		// otherwise the course isn't connected to the LMS for some reason...
		else {
			//alert the user
			siLog('SCORM', 'COMPLETE', 'ERROR: Course is not connected to the LMS');
		}
	}
}

function setScormIncomplete() {
	if (lmsConnected) {
		var success;
		//... try setting the course status to "completed"
		if (scorm.version === '2004') {
			success = scorm.set('cmi.completion_status', 'completed');
			scorm.set('cmi.success_status', 'failed');
			scorm.set('cmi.score.raw', '0');
			scorm.set('cmi.score.scaled', '1');
			// scorm.set("cmi.score.min", globalVar.minScore);
			// scorm.set("cmi.score.max", globalVar.maxScore);
			// scorm.set("adl.nav.request", "exit")
		} else {
			success = scorm.set('cmi.core.lesson_status', 'incomplete');
			scorm.set('cmi.core.score.raw', '0');
			// scorm.set("cmi.core.score.min", globalVar.minScore);
			// scorm.set("cmi.core.score.max", globalVar.maxScore);
		}
		//If the course was successfully set to "incomplete"...
		if (success) {
			scorm.save();
			siLog('SCORM', 'INCOMPLETE', 'SUCCESS: Course was successfully set to incomplete!');
		}
		//If the course couldn't be set to incomplete for some reason...
		else {
			//alert the user
			siLog('SCORM', 'INCOMPLETE', 'ERROR: Course could not be set to incomplete!');
		}
	}
	//If the course isn't connected to the LMS for some reason...
	else {
		//alert the user
		siLog('SCORM', 'INCOMPLETE', 'ERROR: Course is not connected to the LMS');
	}
}

function unloadHandler() {
	saveData.lastSlideType = slides[globalVar.curSlide].type;
	if (slides[globalVar.curSlide].type === 'video' && globalVar.scormSettings.bookmarking.videoBookmarking) {
		saveData.currentVideoTime = videojs(globalVar.$curSlide.find('video')[0].id).currentTime();
	}
	if (lmsConnected && !unloaded) {
		saveLMS();
		scorm.save(); //save all data that has already been sent
		scorm.quit(); //close the SCORM API connection properly
		unloaded = true;
	} else if (globalVar.scormSettings.useLocal && !unloaded) {
		saveProgressLocally();
		unloaded = true;
	}
}
function saveLMS() {
	if (saveCourseProgress() && saveBookmark()) {
		scorm.save();
	} else {
		siLog('SCORM', 'Failed to Save');
	}
}

function saveCourseProgress() {
	var success;
	var dataString;
	if (lmsConnected) {
		if (scorm.version === '2004') {
			scorm.set('cmi.score.raw', saveData.score);
			saveData.totalTime = scorm.get('cmi.total_time') || saveData.totalTime;
		} else {
			scorm.set('cmi.core.score.raw', saveData.score);
			saveData.totalTime = scorm.get('cmi.core.total_time') || saveData.totalTime;
		}
		dataString = JSON.stringify(saveData);
		success = scorm.set('cmi.suspend_data', dataString);
	}
	return success;
}
function saveBookmark() {
	var success;
	saveData.bookmark = slides[globalVar.curSlide].slideNumber || '1';
	if (lmsConnected) {
		if (scorm.version === '2004') {
			success = scorm.set('cmi.location', saveData.bookmark);
		} else {
			success = scorm.set('cmi.core.lesson_location', saveData.bookmark);
		}
	}

	return success;
}

function saveProgressLocally() {
	saveData.bookmark = slides[globalVar.curSlide].slideNumber || '1';
	var dataString = JSON.stringify(saveData);
	if (storageAvailable('localStorage')) {
		localStorage.setItem(progressURL, dataString);
	}
}

function storageAvailable(type) {
	var storage;
	try {
		storage = window[type];
		var x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return (
			e instanceof DOMException &&
			// everything except Firefox
			(e.code === 22 ||
				// Firefox
				e.code === 1014 ||
				// test name field too, because code might not be present
				// everything except Firefox
				e.name === 'QuotaExceededError' ||
				// Firefox
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
			// acknowledge QuotaExceededError only if there's something already stored
			storage &&
			storage.length !== 0
		);
	}
}
